/**
 * @file Определения функций сортировки для каталога.
 * Экспортирует объект с именованными компараторами, применяемыми к отфильтрованным элементам каталога.
 */

/**
 * Сортирует элементы по числовому свойству в убывающем порядке. Равные значения (в том числе отсутствующие у этого каталога)
 * дают 0 — решает следующий ключ цепочки, а не порядок разметки. Иначе первый же неприменимый ключ
 * (у товаров нет ни виджета, ни заполненности) возвращал бы разницу originalIndex и обрывал сортировку на исходном порядке.
 * Элементы с null-значением помещаются в конец.
 * @param {object} a
 * @param {object} b
 * @param {string} property - Имя числового свойства для сравнения.
 * @returns {number}
 */
function compareDescending(a, b, property) {
  const aValue = a[property]
  const bValue = b[property]

  if (aValue === bValue) return 0
  if (aValue === null) return 1
  if (bValue === null) return -1

  return bValue - aValue
}

/**
 * Именованные компараторы сортировки каталога.
 * - `default` — исходный порядок элементов.
 * - `high-rating` — ручной бонус, виджет, рейтинг, заполненность карточки.
 * - `new` — по убыванию даты создания.
 * @type {Object.<string, function(object, object): number>}
 */
const sortDefinitions = {
  'default': function (a, b) {
    return a.originalIndex - b.originalIndex
  },

  // Повторяет серверную формулу (Club::CATALOG_ORDER): ручной бонус, установленный виджет, рейтинг, заполненность карточки,
  // затем порядок разметки (число отзывов, id). Каждый ключ обязан быть и здесь: сортировка по умолчанию — «high-rating»,
  // клиент применяет её сразу на загрузке, и любой пропущенный ключ сбрасывал бы серверный порядок.
  // Каталоги без части ключей (товары — только рейтинг) работают той же цепочкой: отсутствующий ключ даёт 0 и пропускает ход дальше.
  'high-rating': function (a, b) {
    return (
      compareDescending(a, b, 'sortManual') ||
      compareDescending(a, b, 'widget') ||
      compareDescending(a, b, 'rating') ||
      compareDescending(a, b, 'completeness') ||
      a.originalIndex - b.originalIndex
    )
  },

  'new': function (a, b) {
    return (
      compareDescending(a, b, 'createdAt') || a.originalIndex - b.originalIndex
    )
  }
}

export default sortDefinitions
